import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';
import { GUEST_LIST_MESSAGE } from '../constants/guestList';
import { TOAST_SEVERITY } from '../constants/toast';
import { AvailableRooms, Booking, getAvailableRooms, getGuests } from '../services/api';
import { toastActions } from './toastSlice';
import { GuestListFilters, guestListActions } from './guestListSlice';

/** Loads bookings for the current GuestList search filters. */
export function* fetchGuestsWorker(action: PayloadAction<GuestListFilters>) {
  try {
    const data: Booking[] = yield call(getGuests, action.payload);
    yield put(guestListActions.fetchGuestsSuccess(data));
  } catch {
    yield put(guestListActions.fetchGuestsFailure());
    yield put(toastActions.showToast({ message: GUEST_LIST_MESSAGE.FETCH_FAILED, severity: TOAST_SEVERITY.ERROR }));
  }
}

/** Loads available rooms for the selected booking date. */
export function* fetchRoomAvailabilityWorker(action: PayloadAction<string>) {
  try {
    const data: AvailableRooms = yield call(getAvailableRooms, action.payload);
    yield put(guestListActions.fetchRoomAvailabilitySuccess({ date: action.payload, data }));
  } catch {
    yield put(guestListActions.fetchRoomAvailabilityFailure());
  }
}

/** Watches GuestList actions that require API side effects. */
export function* guestListSaga() {
  yield takeLatest(guestListActions.fetchGuestsRequest.type, fetchGuestsWorker);
  yield takeLatest(guestListActions.fetchRoomAvailabilityRequest.type, fetchRoomAvailabilityWorker);
}
